import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaUserTie } from "react-icons/fa6";
import JobRoles from "./index";
import ViewJobRole from "./view";
import EditJobRole from "./edit";
import { MODULE_JOBROLES } from "variables/constants";

const jobRoleRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Job Roles",
		basePath: "job-roles",
		mainComponent: <JobRoles />,
	    layout: "/console",
		icon: <FaUserTie className="icon-item"/>,
	    subTitle:"Job Role",
	    viewComponent: <ViewJobRole/>,
	    createComponent: <EditJobRole />,
	    editComponent: <EditJobRole />,
		level:3,
		moduleId: MODULE_JOBROLES,
	})
]

export default jobRoleRoutes;